<div class="chips-tags-container">
  @for (tag of tags; track tag) {
    <aa-chips-tag-item [tag]="tag"
      (detachTagEvent)="onDetachTagEvent(tag.tagId)"
      (tagClickEvent)="onTagClickEvent(tag)"
      [isFiltrable]="isFiltrable">
    </aa-chips-tag-item>
  }
  <aa-chips-tag-input [tags]="tags"
    (attachTagEvent)="onAttachTagEvent($event)">
  </aa-chips-tag-input>
</div>
